import { NgModule } from '@angular/core';

import { ShipmentsRoutingModule } from './shipments-routing.module';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import { ShipmentsComponent } from './components/shipments.component';
import { ShipmentListingComponent } from './components/shipment-listing/shipment-listing.component';
import { ShipmentBookingsComponent } from './components/shipment-bookings/shipment-bookings.component';
import { ShipmentTableComponent } from './components/shipment-table/shipment-table.component';
import { FirstColumnListingComponent } from './components/first-column-listing/first-column-listing.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

import { NgbModule, NgbPopoverModule, NgbDropdownModule  } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentBookingsComponent } from './components/attachment-bookings/attachment-bookings.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { CustomBadgeRendererComponent } from 'src/app/components/custom-badge-renderer/custom-badge-renderer.component';
import { ShipmentListingV2Component } from './components/shipment-listing-v2/shipment-listing-v2.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PdfJsViewerModule,
    NgSelectModule,
    AgGridModule,
    NgbModule,
    NgbPopoverModule,
    NgbDropdownModule,
    ShipmentsRoutingModule,
    SharedModule
  ],
  declarations: [
    ShipmentsComponent,
    ShipmentListingComponent,
    ShipmentListingV2Component,
    ShipmentBookingsComponent,
    ShipmentTableComponent,
    FirstColumnListingComponent,
    AttachmentBookingsComponent,
    ActionButtonsComponent,
    CustomBadgeRendererComponent
  ]
})

export class ShipmentsModule {

}
